import dark_theme  from './themes/dark';
import light_theme  from './themes/light';
import color_theme from './themes/color';

const map_themes = {
    dark:dark_theme,
    light:light_theme,
    color:color_theme
}
let map; 
// initialise le bloc google map
async function initGoogleMapBlock(){
    const  mapData = await wp.apiFetch({path:"/cdm-map/map_data/"}).then(json=>json); //Données viennent du endpoint savé dans functions.php du block
    const container = document.querySelector("#cdm-map");
    if(!container){
        console.error('Google map codems block: check if container exists.')
        return;
    };
    if( !window.google){
        console.error('Google map codems block: check if google map is enqueued. (is the "GOOGLE_MAP_API" constant defined in wp-config?)')
        return;
    };
    if(!window.google.maps){
        console.error('Google map codems block: check if google map is enqueued. (is the "GOOGLE_MAP_API" constant defined in wp-config?)')
        return;
    };

    const theme = map_themes[container.getAttribute('data-theme')];

    const mapOptions = {
        zoom: 12,
        scrollwheel : false,
        zoomControl: true,
        disableDefaultUI: true,
        iconColor:container.getAttribute('data-icon-color'),
        // center: markerPos, //TODO
        center: new google.maps.LatLng(mapData.main_address.lat-0.02,mapData.main_address.lng-0.03),
        labelContent: mapData.site_name, //TODO
        mapId: "609efa3827fba67170fb1967"
    }

    map = new google.maps.Map(container, mapOptions);
    map.mapTypes.set(theme.id,  new google.maps.StyledMapType(theme.theme, {name:theme.id}));
    const bounds = new google.maps.LatLngBounds();

    cdmMapAddMarker(map,bounds,mapData.main_address,mapData.site_logo);
    container.classList.remove('loading');
}

function cdmMapAddMarker(map,bounds,acf_adress,logo = "",icon = null){
    const defaultIcon = {
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
            fillColor: map.iconColor,
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 0.1,
            anchor: new google.maps.Point(150, 500),
    }
    const htmlMarker = document.createElement('div');
    htmlMarker.classList.add('marker-container');

    const svgTemplate = 
        `<?xml version="1.0" encoding="UTF-8"?>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214 214" width='220' height='220'>
        <defs><style>.cls-1{letter-spacing:0em;}.cls-2{fill:#fff;}.cls-3{font-size:30px;font-size:800}.cls-4{fill:#165aa5;}.cls-4,.cls-5{font-family:Montserrat-SemiBold, Montserrat;}.cls-6,.cls-5{font-size:12px;}.cls-7{letter-spacing:-.01em;}.cls-8{fill:#e7e9e9;}.cls-5{fill:#818386;}</style></defs>
            <g id="Layer_1-2">
                <g>
                    <path class="cls-2" d="M214,107c0,59.09-47.91,107-107,107S0,166.09,0,107,47.91,0,107,0c25.43,0,48.78,8.87,67.14,23.68l33.21,.16-12.61,21.89c12.15,17.36,19.27,38.48,19.27,61.27Z" />
                    <g>
                        <text class="cls-4" transform="translate(107 69.8)">
                            <tspan class="cls-3">
                                <tspan style="font-weight:700;" x="1" y="0" text-anchor="middle">{{numero}}</tspan>
                            </tspan>
                            <tspan class="cls-6">
                                <tspan style="font-size:12px;font-weight:600;font-family:Montserrat;fill:#165aa5;" class="cls-1" x="-3" y="20" text-anchor="middle">{{address}}</tspan>
                            </tspan>
                        </text>
                        <rect class="cls-8" x="30.52" y="110.51" width="152.95" height="3" />
                        <text class="cls-5" transform="translate(107 144.02)">
                            <tspan style="font-size:12px;font-weight:600;font-family:Montserrat;fill:#818386;" class="cls-1" x="-3" y="0"  text-anchor="middle">
                                {{ville}}
                            </tspan>
                            <tspan style="font-size:12px;font-weight:600;font-family:Montserrat;fill:#818386;" class="cls-1" x="-3" y="16"  text-anchor="middle">
                                {{pays}}
                            </tspan>
                        </text>
                    </g>
                </g>
            </g>
        </svg>`;

    const svg = svgTemplate.replace('{{numero}}',acf_adress.street_number).replace('{{address}}',acf_adress.street_name).replace('{{ville}}',`${acf_adress.city}, ${acf_adress.state_short}`).replace('{{pays}}',acf_adress.country);

    htmlMarker.innerHTML = svg;

    const marker = new google.maps.marker.AdvancedMarkerElement({
        position: new google.maps.LatLng(acf_adress.lat, acf_adress.lng),
        map: map,
        content: htmlMarker,
    });

    

    const infoWindow = new google.maps.InfoWindow({
        content: `  <div class="content-infopup-wrapper">
                        ${logo}
                        <a data-direction="${acf_adress.address}" href="https://www.google.ca/maps/dir/${encodeURIComponent(acf_adress.address)}" target="_blank" rel="nooponer">${acf_adress.address}</a>
                        <a data-direction="${acf_adress.address}" href="https://www.google.ca/maps/dir/${encodeURIComponent(acf_adress.address)}" target="_blank" rel="nooponer">${wp.i18n._x('Directions','cdm-map','theme_client')}</a>
                    </div>`
    });

    marker.addListener('click', function() {
        infoWindow.open(map, marker);
    });

    bounds.extend(new google.maps.LatLng(acf_adress.lat, acf_adress.lng));
}

cdm_blocks.fn.ready(()=>{
    if(!document.body.classList.contains('wp-admin') ){
        
        initGoogleMapBlock();
    }
});


